import React, { useState, useEffect } from "react";
import Header from "../../components/header";
import styles from "./InformePresupuestos.module.css";
import History from "../../components/history";
import { Button, Form, Table, Pagination, Row, Col } from "react-bootstrap";
import { useCookies } from 'react-cookie';
import axios from 'axios';
import { checkSession, isMobile } from "../../core/session";
import Notifications, {notify} from "react-notify-toast";
import TimeFilter from "../../components/time-filter"
import {formatAmount} from "../../core/amount";
import { displayDate } from "../../core/date";
import GastoDetail from "./GastoDetail";
import ReportAccountsPreview from "./ReportAccountsPreview";
import ReportConsolidadoPreview from "./ReportConsolidadoPreview/ReportConsolidadoPreview";
import ReportConsolidadoMensualPreview from "./ReportConsolidadoMensualPreview";
import ReportGeneralPreview from "./ReportGeneralPreview";
import ReportComparativaPreview from "./ReportComparativaPreview";
import ReportConsolidadoEmpresasPreview from "./ReportConsolidadoEmpresasPreview";
import ReportMensualPreview from "./ReportMensualPreview";

const InformePresupuestos = (props) => {

    const loadingBtn = require("../../assets/loaders/btn-loading.gif");

    const [loading, setLoading] = useState(false);
    const [loadingPrev, setLoadingPrev] = useState(false);
    const [loadingXls, setLoadingXls] = useState(false);
    const [cookie, setCookies, removeCookie] = useCookies(['kUserSession']);

    const [fechaDesde, setFechaDesde] = useState(undefined);
    const [fechaHasta, setFechaHasta] = useState(undefined);

    const [account, setAccount] = useState(undefined);

    const [expense, setExpense] = useState(undefined);
    const [showExpenseDetail, setShowExpenseDetail] = useState(false);

    const [provider, setProvider] = useState(undefined);
    const [tipoInforme, setTipoInforme] = useState("P");
    
    const [mes, setMes] = useState(0);
    const [year, setYear] = useState(new Date().getFullYear());

    const [mesInicial, setMesInicial] = useState(1);
    const [mesFinal, setMesFinal] = useState(1);

    const [anho, setAnho] = useState(new Date().getFullYear());
    const [anho2, setAnho2] = useState(new Date().getFullYear());
    
    const mesesMap = {
        "JANUARY": "Enero",
        "FEBRUARY": "Febrero",
        "MARCH": "Marzo",
        "APRIL": "Abril",
        "MAY": "Mayo",
        "JUNE": "Junio",
        "JULY": "Julio",
        "AUGUST": "Agosto",
        "SEPTEMBER": "Septiembre",
        "OCTOBER": "Octubre",
        "NOVEMBER": "Noviembre",
        "DECEMBER": "Diciembre"
    };

    const [data, setData] = useState(undefined);
    
    const history = [
        {
            name: "Inicio",
            path: "/"
        },
        {
            name: "Presupuestos",
            path: "/presupuestos"
        }
    ]

    const prepareHeaders = () => {
        return {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                "api_key": "k-randa",
                "access_token": cookie.kUserSession.data.access_token
            }
        };
    }

    const getInforme = () => {
        setLoading(true);
        const { id:idEstancia } = cookie.kUserSession.data["farm"];
        const tipo = tipoInforme == "P" ? "PRESUPUESTO" : "INVERSION";
        const mesParam = mes != 0 ? mes : "";
        axios.get(process.env.REACT_APP_API_URL + `presupuestos/informe?estancia=${idEstancia}&periodo=${year}&tipo=${tipo}&mes=${mesParam}`, prepareHeaders()).
        then((response) => {
            setLoading(false);
            console.log(response.data);
            setData(response.data);
        }).
        catch((error) => {
            console.error("Error al obtener el informe de presupuestos:", error);
            setLoading(false);
            setData(undefined);
        });
    }

    const generarExcel = (e) => {
        e.preventDefault();
        setLoadingXls(true);
        const { id:idEstancia } = cookie.kUserSession.data["farm"];
        const tipo = tipoInforme == "P" ? "PRESUPUESTO" : "INVERSION";
        const mesParam = mes != 0 ? `&mes=${mes}` : "";
        const url = `presupuestos/informe/report?estancia=${idEstancia}&periodo=${year}&tipo=${tipo}${mesParam}`;
        fetch(process.env.REACT_APP_API_URL + url, prepareHeaders())
        .then(response => {
            const filename = response.headers.get("content-disposition").split("filename=")[1];
            response.blob().then(blob => {
                let url = window.URL.createObjectURL(blob);
                let a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();
                setLoadingXls(false);
                notify.show("Reporte generado exitosamente", "success");
            });
        }).catch(error => {
            notify.show("Ha ocurrido un error al generar el reporte", "error");
            console.error(error);
            setLoadingXls(false);
        });
    }

    useEffect(() => { getInforme(); }, []);
    useEffect(() => { getInforme(); }, [ year, mes, tipoInforme]);    

    return (
        <>
            <GastoDetail show={showExpenseDetail} handleClose={(e) => {setShowExpenseDetail(false);}} data={expense}/>
            <Notifications />
            <Header history={props.history} />
            <section className={styles.body}>
                <Row>
                    <Col>
                        <History items={history} current={"Informes"} history={props.history} />
                    </Col>
                </Row>
                <Row>
                    <Col md={2}>
                        <section className={styles.side}>
                            <Form className={styles.searchForm}>
                                <Row>
                                    <Col>
                                        <Form.Group style={{marginBottom: "15px"}}>
                                            <Form.Label htmlFor="periodo" className={styles.label}>Periodo</Form.Label>
                                            <Form.Control id="periodo" className={"karanda-input"} value={year} onChange={(e) => {setYear(e.target.value); }} type="number"/>
                                        </Form.Group>                                                
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Group style={{marginBottom: "15px"}}>
                                            <Form.Label htmlFor="mes" className={styles.label}>Mes</Form.Label>
                                            <Form.Control id="mes" className={"karanda-input"} value={mes} onChange={(e) => {setMes(e.target.value); }} as={"select"}>
                                                <option value="0">TODOS</option>
                                                <option value="JANUARY">Enero</option>
                                                <option value="FEBRUARY">Febrero</option>
                                                <option value="MARCH">Marzo</option>
                                                <option value="APRIL">Abril</option>
                                                <option value="MAY">Mayo</option>
                                                <option value="JUNE">Junio</option>
                                                <option value="JULY">Julio</option>
                                                <option value="AUGUST">Agosto</option>
                                                <option value="SEPTEMBER">Septiembre</option>
                                                <option value="OCTOBER">Octubre</option>
                                                <option value="NOVEMBER">Noviembre</option>
                                                <option value="DECEMBER">Diciembre</option>                                                          
                                            </Form.Control>
                                        </Form.Group>                                                
                                    </Col>
                                </Row>                                            
                                <Row>
                                    <Col>
                                        <Form.Group style={{marginBottom: "15px"}}>
                                            <Form.Label className={styles.label}>Tipo de informe</Form.Label>
                                            <Form.Control className={"karanda-input"} as="select" value={tipoInforme} onChange={(e) => {setTipoInforme(e.target.value);}}>
                                                <option value="P">Presupuestos</option>
                                                <option value="I">Inversiones</option>
                                            </Form.Control>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Button className="karanda-btn" disabled={loading} onClick={getInforme} >
                                            Previsualizar
                                            {
                                                loading ? (
                                                    <>
                                                        &nbsp;&nbsp;<img src={loadingBtn} height="15" />
                                                    </>
                                                ) : <></>
                                            }
                                        </Button>                                    
                                    </Col>
                                </Row>
                                <br></br>
                                <Row>
                                    <Col>
                                        <Button className="karanda-btn" disabled={loadingXls} onClick={generarExcel}>
                                            Descargar excel
                                            {
                                                loadingXls ? (
                                                    <>
                                                        &nbsp;&nbsp;<img src={loadingBtn} height="15" />
                                                    </>
                                                ) : <></>
                                            }
                                        </Button>

                                    </Col>
                                </Row>
                            </Form>                            
                        </section>
                    </Col>
                    <Col md={10}>
                        <section className={styles.content}>
                            <h1 className={styles.title}>Informes</h1>
                            <section className={styles.actions}>
                                <section style={{marginTop: "1em"}}>
                                {
                                    data ? (
                                        <div style={{ overflowX: 'auto' }}>
                                            <Table className="karanda-table">
                                                <thead>
                                                    <tr>
                                                        <th rowSpan="2" className={styles.stickyHeader} style={{ fontSize: "18px" }}>CATEGORÍA</th>
                                                        {data.totalesPorMes.map((mes) => (
                                                            <th style={{ borderLeft: "1px solid silver", borderRight: "1px solid silver", fontSize: "22px" }} key={mes.mes} colSpan="3">{mesesMap[mes.mes].toUpperCase()}</th>
                                                        ))}
                                                        <th colSpan="3" style={{ background: "#339966", color: "white", fontSize: "22px" }}>ACUMULADO</th>
                                                    </tr>
                                                    <tr>
                                                        {data.totalesPorMes.map((mes) => (
                                                            <>
                                                                <th style={{ borderLeft: "1px solid silver" }} key={`${mes.mes}-estipulado`}>ESTIPULADO</th>
                                                                <th key={`${mes.mes}-ejecutado`}>EJECUTADO</th>
                                                                <th style={{ borderRight: "1px solid silver" }} key={`${mes.mes}-promedio`}>PROMEDIO</th>
                                                            </>
                                                        ))}
                                                        <th style={{ background: "#339966", color: "white" }}>PRESUPUESTADO</th>
                                                        <th style={{ background: "#339966", color: "white" }}>EJECUTADO</th>
                                                        <th style={{ background: "#339966", color: "white" }}>SALDO</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {data.presupuestos.map((categoria) => (
                                                    <tr key={categoria.categoria}>
                                                        <td className={styles.stickyCell}>{categoria.categoria}</td>
                                                        {data.totalesPorMes.map((mes) => {
                                                        const mesData = categoria.meses.find((m) => m.mes === mes.mes);
                                                        return (
                                                            <>
                                                                <td style={{ borderLeft: "1px solid silver", fontWeight: "bolder" }}  key={`${categoria.categoria}-${mes.mes}-estipulado`}>
                                                                    {mesData?.estipulado?.toLocaleString() ?? "-"}
                                                                </td>
                                                                <td
                                                                    key={`${categoria.categoria}-${mes.mes}-ejecutado`}
                                                                    style={mesData && mesData.ejecutado > mesData.estipulado ? { background: "#ff9999", color: "black" } : {}}
                                                                >
                                                                    {mesData?.ejecutado?.toLocaleString() ?? "-"}
                                                                </td>
                                                                <td
                                                                    style={Object.assign({ borderRight: "1px solid silver" }, mesData && mesData.promedioEjecutado > mesData.estipulado ? { color: "red" } : {})}
                                                                    key={`${categoria.categoria}-${mes.mes}-promedio`}
                                                                >
                                                                    {mesData?.promedioEjecutado?.toLocaleString() ?? "-"}
                                                                </td>
                                                            </>
                                                        );
                                                        })}
                                                        <td>{categoria.acumulado.presupuestado.toLocaleString()}</td>
                                                        <td>{categoria.acumulado.ejecutado.toLocaleString()}</td>
                                                        <td>{categoria.acumulado.saldo.toLocaleString()}</td>
                                                    </tr>
                                                    ))}
                                                </tbody>

                                                <tfoot>
                                                    <tr style={{ fontWeight: "bold", backgroundColor: "#f5f5f5" }}>
                                                        <td className={styles.stickyFooter}>TOTALES</td>
                                                        {data.totalesPorMes.map((mes) => (
                                                            <>
                                                                <td style={{ borderLeft: "1px solid silver" }}  key={`${mes.mes}-estipulado`}>{mes.estipulado.toLocaleString()}</td>
                                                                <td
                                                                    key={`${mes.mes}-ejecutado`}
                                                                    style={mes.ejecutado > mes.estipulado ? { background: "#ff9999", color: "black" } : {}}
                                                                >{mes.ejecutado.toLocaleString()}</td>
                                                                <td
                                                                    style={Object.assign({ borderRight: "1px solid silver" }, mes.promedioEjecutado > mes.estipulado ? { color: "red" } : {})}
                                                                    key={`${mes.mes}-promedio`}
                                                                >{mes.promedioEjecutado.toLocaleString()}</td>
                                                            </>
                                                        ))}
                                                        <td style={{ background: "#339966", color: "white" }}>{data.acumulado.presupuestado.toLocaleString()}</td>
                                                        <td style={{ background: "#339966", color: "white" }}>{data.acumulado.ejecutado.toLocaleString()}</td>
                                                        <td style={{ background: "#339966", color: "white" }}>{data.acumulado.saldo.toLocaleString()}</td>
                                                    </tr>
                                                </tfoot>
                                            </Table>
                                        </div>
                                    )
                                    : 
                                    <span>No hay resultados</span>
                                }
                                </section>
                            </section>
                        </section>                    
                    </Col>
                </Row>
            </section>
        </>
    );

};

export default InformePresupuestos;